import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useApiClient } from '@api-client/context';
import type { SavedFilter, SavedFilterSection } from './index';
import { savedFiltersQueryKeys } from './query-keys';

export function useSavedFiltersQuery(
  section: SavedFilterSection,
  contextId?: number | null,
  options?: Omit<
    UseQueryOptions<SavedFilter[], Error>,
    'queryKey' | 'queryFn'
  >
) {
  const api = useApiClient();

  return useQuery({
    queryKey: savedFiltersQueryKeys.list(section, contextId),
    queryFn: () =>
      api.savedFilters.list({
        section,
        context_id: contextId
      }),
    ...options
  });
}
